import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { instance } from '../../common';

function FindSigong({ isName, isRegion, keyword }) {
	const history = useHistory();
	
  const [data, setData] = useState([]);
  let obj = { si_area1: isName, si_area2: isRegion, keyword: keyword };

  useEffect(() => {
    const fetchData = async () => {
      instance.post("/sigong/select", obj).then(function (res) {
        setData(res.data);
      });
    };

    fetchData();
  }, [isName, isRegion, keyword]);

  const goDetail = (e) => {
    const { id } = e.target.dataset;
    history.push(`/shop/${id}`);
  };

  return (
    <>
      {data.map((v) => (
        <div key={v.si_id} className="py-4 mt-2 wrapFind border-top-0">
          <span>
            {v.si_name}
          </span>
          <span
            className="btn btn-primary btn-sm p rounded-pill float-right"
            data-id={v.si_id}
            onClick={goDetail}
          >
            상세보기
          </span>
        </div>
      ))}
    </>
  );
}

export default FindSigong;
